import pfp from "./assets/img/ascii_small_matrix.png";
import "./App.css";
import config from "./assets/styles/terminalStyle";
import mobileConfig from "./assets/styles/terminalStyleMobile";
import Terminal from "react-console-emulator";
import React, { Component } from "react";
import MediaQuery from "react-responsive";
// ! Pages
import Projects from "./commands/projects.js";
import Ls from "./commands/ls.js";
import Skills from "./commands/skills.js";
import Education from "./commands/education.js";
import Info from "./commands/info.js";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.terminal = React.createRef();
  }
  render() {
    const { globalStyles } = config;
    const { mobileStyles } = mobileConfig;

    return (
      <div className="flex flex-col w-5/6 md:w-5/6 xl:w-4/5 2xl:w-2/4 mx-auto my-8 min-h-screen py-2">
        <div className="my-4">
          <p className="text-white text-sm sm:text-lg">
            <span className="cc-1">michkz </span>
            <span className="cc-2"> ~ </span>
            <span className="cc-3"> › </span>
            fetch
          </p>
        </div>
        <div className=" text-white">
          <div className="lg:flex lg:flex-row">
            <div className="md:mr-16 2xl:c-w-70">
              <img className=" h-full w-full object-cover " src={pfp} />
            </div>
            <div className="flex-grow-1">
              <p className="text-white text-md sm:text-lg my-3 md:mb-2 md:mt-0">
                <span className="cc-1">michkz@home </span>
              </p>
              <p>--------------------</p>
              <div className="grid grid-cols-2 gap-4 place-items-start text-sm sm:text-lg">
                <div className="my-0.5">
                  <p>Name:</p>
                </div>
                <div>
                  <p>Michael Kalil</p>
                </div>
                <div className="my-0.5">
                  <p>Age:</p>
                </div>
                <div>
                  <p>25</p>
                </div>
                <div className="my-0.5">
                  <p>Location:</p>
                </div>
                <div>
                  <p>Eindhoven, NL</p>
                </div>
                <div className="my-0.5">
                  <p>Study:</p>
                </div>
                <div>
                  <p>Infrastructure & Security Management</p>
                </div>
              </div>
              <p>--------------------</p>
              <div className="my-2">
                <p className="text-white text-sm sm:text-lg">
                  <span className="cc-1">michkz </span>
                  <span className="cc-2"> ~ </span>
                  <span className="cc-3"> › </span>
                  help
                </p>
              </div>
              <div className="my-2">
                <p className="text-sm sm:text-lg">
                  To display information, type one of the available
                  <br /> commands &#123;info, skills, education, projects&#125;
                  in the terminal below. Type help if you get stuck.
                  {/* I convert coffee and dreams into code
                  <br /> and reality. One day I’ll understand
                  <br /> malware as if it were my child, but
                  <br /> until that day I’ll keep it to
                  <br /> learning and designing in my free time */}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* //! This is where the terminal starts */}
        {/* //! if statement if max screen-width is 639 for mobile terminal */}
        {/* // ? Mobile View */}
        <MediaQuery maxWidth={639}>
          {/* <p className="text-purple-600">This is really mobile</p> */}
          <Terminal
            ref={this.terminal}
            commands={{
              education: {
                description: "Show my education",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Education), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving education history, please wait... <br />
                    </span>
                  );
                },
              },
              info: {
                description: "Show information about myself",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Info), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving information, please wait... <br />
                    </span>
                  );
                },
              },
              projects: {
                description: "Show my projects",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Projects), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving projects, please wait... <br />
                    </span>
                  );
                },
              },
              skills: {
                description: "Show my skills",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Skills), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving skillbase, please wait... <br />
                    </span>
                  );
                },
              },
            }}
            promptLabel={
              <sp>
                <span className="text-sm sm:text-lg cc-1">michkz </span>
                <span className="text-sm sm:text-lg cc-2"> ~ </span>
                <span className="text-sm sm:text-lg cc-3"> › </span>
              </sp>
            }
            inputTextStyle={{ color: "#FFFFFF" }}
            promptLabelStyle={mobileStyles.promptLabel}
            contentStyle={mobileStyles.content}
            inputStyle={mobileStyles.input}
            inputTextStyle={mobileStyles.inputText}
            messageStyle={mobileStyles.message}
            // TODO: remove padding on left side of component
            style={{
              backgroundColor: "none",
              fontFamilyName: "monospace, monospace",
              padding: "0px",
            }}
            autoFocus
            ignoreCommandCase
            styleEchoBack={"fullInherit"}
          />
        </MediaQuery>
        {/* // ? Larger Mobile / Tablet View */}
        <MediaQuery minWidth={640} maxWidth={1023}>
          {/* <p className="text-white">You are now in Larger Mobile/Tablet View</p> */}
          <Terminal
            ref={this.terminal}
            commands={{
              ls: {
                description: "List directory",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Ls), 1250);
                  return (
                    <span className="cc-3">
                      [!] Retrieving files, please wait... <br />
                    </span>
                  );
                },
              },
              education: {
                description: "Show my education",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Education), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving education history, please wait... <br />
                    </span>
                  );
                },
              },
              info: {
                description: "Show information about myself",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Info), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving information, please wait... <br />
                    </span>
                  );
                },
              },
              projects: {
                description: "Show my projects",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Projects), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving projects, please wait... <br />
                    </span>
                  );
                },
              },
              skills: {
                description: "Show my skills",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Skills), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving skillbase, please wait... <br />
                    </span>
                  );
                },
              },
            }}
            promptLabel={
              <sp>
                <span className="text-sm sm:text-lg cc-1">michkz </span>
                <span className="text-sm sm:text-lg cc-2"> ~ </span>
                <span className="text-sm sm:text-lg cc-3"> › </span>
              </sp>
            }
            inputTextStyle={{ color: "#FFFFFF" }}
            promptLabelStyle={globalStyles.promptLabel}
            contentStyle={globalStyles.content}
            inputStyle={globalStyles.input}
            inputTextStyle={globalStyles.inputText}
            messageStyle={globalStyles.message}
            // TODO: remove padding on left side of component
            style={{
              backgroundColor: "none",
              fontFamilyName: "monospace, monospace",
              padding: "0px",
            }}
            autoFocus
            ignoreCommandCase
            styleEchoBack={"fullInherit"}
          />
        </MediaQuery>
        {/* // ? Desktop View */}
        <MediaQuery minWidth={1024}>
          <Terminal
            ref={this.terminal}
            // TODO: create command to download cv.jpg
            commands={{
              ls: {
                description: "List directory",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Ls), 1250);
                  return (
                    <span className="cc-3">
                      [!] Retrieving files, please wait... <br />
                    </span>
                  );
                },
              },
              education: {
                description: "Show my education",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Education), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving education history, please wait... <br />
                    </span>
                  );
                },
              },
              info: {
                description: "Show information about myself",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Info), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving information, please wait... <br />
                    </span>
                  );
                },
              },
              projects: {
                description: "Show my projects",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Projects), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving projects, please wait... <br />
                    </span>
                  );
                },
              },
              skills: {
                description: "Show my skills",
                fn: () => {
                  const terminal = this.terminal.current;
                  setTimeout(() => terminal.pushToStdout(Skills), 1250);
                  return (
                    <span className="cc-3">
                      {""}
                      [!] Retrieving skillbase, please wait... <br />
                    </span>
                  );
                },
              },
            }}
            promptLabel={
              <sp>
                <span className="text-sm sm:text-lg cc-1">michkz </span>
                <span className="text-sm sm:text-lg cc-2"> ~ </span>
                <span className="text-sm sm:text-lg cc-3"> › </span>
              </sp>
            }
            inputTextStyle={{ color: "#FFFFFF" }}
            promptLabelStyle={globalStyles.promptLabel}
            contentStyle={globalStyles.content}
            inputStyle={globalStyles.input}
            inputTextStyle={globalStyles.inputText}
            messageStyle={globalStyles.message}
            // TODO: remove padding on left side of component
            style={{
              backgroundColor: "none",
              fontFamilyName: "monospace, monospace",
              padding: "0px",
            }}
            autoFocus
            ignoreCommandCase
            styleEchoBack={"fullInherit"}
          />
        </MediaQuery>
      </div>
    );
  }
}
